import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

const Headline = ({ header, title, image, className }) => (
  <div className={cn('headline', className)}>
    {
      image && <img src={image} alt="LendingUSA" />
    }
    <h1>{header}</h1>
    <p>{title}</p>
  </div>
);

Headline.propTypes = {
  image: PropTypes.any,
  header: PropTypes.node.isRequired,
  title: PropTypes.node,
  className: PropTypes.string,
};

Headline.defaultProps = {
  title: '',
  image: null,
  className: '',
};

export default Headline;
